function initReviewSliders() {
    document.querySelectorAll('.mf_pdp-testimonial-main-wrapper.mySwiper').forEach((el) => {
      const isMobile = window.innerWidth <= 750;
  
      const existingSwiper = el.swiper;
  
      if (isMobile && !existingSwiper) {
        // Init swiper...
        let paginationEl = el.querySelector('.swiper-pagination');
        el.dataset.swiperInitialized = 'true';
  
        new Swiper(el, {
          slidesPerView: 1,
          spaceBetween: 20,
          loop: true,
          speed: 600,
          autoplay: {
            delay: 3000,
            disableOnInteraction: false,
          },
          pagination: {
            el: paginationEl,
            clickable: true,
          },
        });
      } else if (!isMobile && existingSwiper) {
        // Destroy if > 750...
        existingSwiper.destroy(true, true);
        el.removeAttribute('data-swiper-initialized');
      }
    });
  }
  
  // Run on load...
  initReviewSliders();
  
  // Run on resize...
  window.addEventListener('resize', () => {
    initReviewSliders();
  });
  